/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const paymentTypeEnumSchema = z.enum(["card", "bonus", "external"]).describe("* `card` - Карта\n* `bonus` - Бонусы\n* `external` - Внешний");
